import { render, staticRenderFns } from "./copy-item-dialog.vue?vue&type=template&id=2894d42e&"
import script from "./copy-item-dialog.vue?vue&type=script&lang=js&"
export * from "./copy-item-dialog.vue?vue&type=script&lang=js&"
import style0 from "./copy-item-dialog.vue?vue&type=style&index=0&id=2894d42e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2894d42e')) {
      api.createRecord('2894d42e', component.options)
    } else {
      api.reload('2894d42e', component.options)
    }
    module.hot.accept("./copy-item-dialog.vue?vue&type=template&id=2894d42e&", function () {
      api.rerender('2894d42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseOrders/copy-item-dialog.vue"
export default component.exports